import { render, staticRenderFns } from "./SysBar.vue?vue&type=template&id=b455eb02&scoped=true&lang=pug"
import script from "./SysBar.vue?vue&type=script&lang=js"
export * from "./SysBar.vue?vue&type=script&lang=js"
import style0 from "./SysBar.vue?vue&type=style&index=0&id=b455eb02&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b455eb02",
  null
  
)

export default component.exports